<template>
  <div class="inventarView">
    <div class="action-buttons">
        <div class="left-buttons mar-rt-10">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group mar-rt-10" style="flex: 1;">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.gestiune') }}</label>
              <el-select
                  v-model="selectedGestiune"
                  placeholder="Selectează gestiunea"
                  :disabled="loading"
                >
                <el-option
                  v-for="gestiune in filteredGestiuni"
                  :key="gestiune.id"
                  :label="gestiune.name"
                  :value="gestiune.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group mar-rt-10" style="flex: 1;">
              <label>{{ $t('gestiune.status') }}</label>
              <select v-model="selectedStatus" class="form-control">
                <option value="">Toate</option>
                <option value="DRAFT">Nefinalizat</option>
                <option value="VALIDATED">Validat</option>
              </select>
            </div>
          </div>
          <div class="search-button-reports">
            <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="onSearch"
            >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
            </button>
          </div>
        </div>
        <div class="right-buttons">
          <button class="btn add mar-rt-10"  @click.prevent="addInventory" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/add.png">
            {{$t('gestiune.addInventory')}}
          </button>
        </div>
    </div>
    <div class="card mar-to-15">
      <div class="card-content">
        <div class="data-table">
          <el-table :data="tableData" v-loading="loading" :empty-text="$t('gestiune.noData')" element-loading-text="Se încarcă...">
            <el-table-column prop="number" :label="$t('gestiune.nr')" width="100"></el-table-column>
            <el-table-column prop="series" :label="$t('invoice.series')" width="70"></el-table-column>
            <el-table-column
              prop="state"
              :label="$t('gestiune.status')"
              width="120"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    backgroundColor: scope.row.state === 'VALIDATED' ? '#67C23A' : '#909399',
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '50px',
                    fontSize: '12px',
                    display: 'inline-block'
                  }"
                >
                  {{ scope.row.state }}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('gestiune.gestiune')" width="200">
              <template slot-scope="scope">
                {{getGestiuneNameById(scope.row.gestiune)}}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="differences" :label="$t('gestiune.differences')"></el-table-column> -->
            <!-- <el-table-column prop="note" :label="$t('gestiune.note')"></el-table-column> -->
            <!-- <el-table-column prop="date" :label="$t('gestiune.date')" :formatter="formatDate"></el-table-column> -->
            <el-table-column :label="$t('gestiune.date')">
              <template slot-scope="scope">
                {{formatDate(scope.row.date)}}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="scriptDate" :label="$t('gestiune.scriptDate')" :formatter="formatDate"></el-table-column> -->
            <el-table-column :label="$t('general.actions')" width="100">
              <template slot-scope="scope">
                <el-dropdown trigger="click" placement="bottom-end">
                  <!-- Trigger: sageata jos cu border violet -->
                  <span class="arrow-box">
                    &#9662; <!-- sageata jos -->
                  </span>
                  <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <!-- Edit -->
                    <el-dropdown-item
                      v-if="scope.row.state != 'VALIDATED'"
                      @click.native="editInventory(scope.row)">
                      {{$t('general.edit')}}
                    </el-dropdown-item>
                    <!-- See -->
                    <el-dropdown-item
                      v-if="scope.row.state == 'VALIDATED'"
                      @click.native="editInventory(scope.row)">
                      {{$t('general.see')}}
                    </el-dropdown-item>
                    <!-- Download -->
                    <el-dropdown-item @click.native="downloadPdf(scope.row)">
                      {{$t('invoice.download')}}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="downloadExcel(scope.row)">
                      {{$t('gestiune.downloadExcel')}}
                    </el-dropdown-item>
                    <!-- Delete -->
                    <el-dropdown-item
                      v-if="scope.row.state != 'VALIDATED'"
                      @click.native="deleteInventory(scope.row)"
                      style="color: red; font-weight: bold;">
                      {{$t('general.delete')}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change="handlePageChange"
              style="margin-top: 15px; text-align: right;"
            ></el-pagination>
          <div v-if="!tableData.length && !loading" style="text-align:center; margin-top:20px;">
            Nu există inventare pentru criteriile selectate.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  export default {
    // components: {
    //   GeneralTopBar
    // },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      },
      gestiuneOptions: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        loadingTimeout: null,
        totalItems: 0,
        currentPage: 1,
        pageSize: 50,
        selectedLocation: null,
        selectedGestiune: null,
        tableData: [],
        gestiuniList: [],
        selectedStatus: '',
        selectedManagement: ''
      }
    },
    watch: {
      selectedLocation (newLocation) {
        this.selectedGestiune = null
        this.tableData = []

        if (this.filteredGestiuni && this.filteredGestiuni.length) {
          this.selectedGestiune = this.filteredGestiuni[0].id
        }
      },
      selectedGestiune (newGestiune) {
        this.searchTerm = null
        this.tableData = []
      }
    },
    computed: {
      filteredGestiuni () {
        if (!this.selectedLocation) return []
        const result = this.gestiuneOptions.filter(
          (g) => g.externalLocationId === this.selectedLocation.true_id
        )
        return result
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0]
      }

      this.$bus.$on('refresh', this.handleRefresh)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.fetchInventare()
      },
      onSearch () {
        // Validare locație
        if (!this.selectedLocation) {
          swal({
            type: 'warning',
            title: this.$t('general.required'),
            text: 'Selectați o locație',
            confirmButtonText: 'OK'
          })
          return
        }

        // Validare gestiune
        if (!this.selectedGestiune) {
          swal({
            type: 'warning',
            title: this.$t('general.required'),
            text: 'Selectați o gestiune',
            confirmButtonText: 'OK'
          })
          return
        }

        // Apelăm fetch-ul
        this.fetchInventare()
      },
      handlePageChange (page) {
        this.currentPage = page
        this.fetchInventare(this.currentPage, this.pageSize)
      },
      getGestiuneNameById (id) {
        const gest = this.gestiuneOptions.find(g => g._id === id || g.id === id)
        return gest ? gest.name : id
      },
      addInventory () {
        this.$router.push('/management/inventory/add')
      },
      async fetchGestiuni () {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
          if (!response.ok) throw new Error('Failed to fetch gestiuni')
          const data = await response.json()

          if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
            this.gestiuniList = data.gestiuni.map(gest => ({
              id: gest._id,
              value: gest._id,
              label: `${gest.name} (${gest.cod_gestiune})`
            }))
          } else {
            swal.fire({
              icon: 'error',
              title: 'Eroare!',
              text: 'Nu s-a primit un array valid de la server.',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          swal.fire({
            icon: 'error',
            title: 'Eroare!',
            text: `Request failed: ${error.message}`,
            timer: 2000,
            showConfirmButton: false
          })
          console.error('Error fetching management data:', error)
        }
      },
      async fetchInventare (page = 1, pageSize = 25) {
        if (!this.companyID) return
        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = setTimeout(() => {
          this.loading = true
        }, 100)
        try {
          const params = new URLSearchParams()
          params.append('externalCompanyId', this.companyID)
          if (this.selectedManagement) params.append('externalLocationId', this.selectedManagement)
          if (this.selectedStatus) params.append('state', this.selectedStatus)

          if (this.selectedLocation) params.append('externalLocationId', this.selectedLocation.true_id)
          if (this.selectedGestiune) params.append('gestiune', this.selectedGestiune)
          params.append('page', page)
          params.append('limit', pageSize)

          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/inventare?${params.toString()}`)
          if (!response.ok) throw new Error('Failed to fetch inventare')

          const data = await response.json()

          this.totalItems = data.total || 0
          this.currentPage = data.currentPage || page
          this.pageSize = data.pageSize || pageSize

          // presupunem că inventarele au câmpurile: series, number, state, gestiune, differences, note, date, scriptDate
          this.tableData = data.inventare.map(inv => ({
            series: inv.series || '',
            number: inv.number || '',
            state: inv.state || '',
            gestiune: inv.gestiune ? inv.gestiune.name || inv.gestiune : '',
            differences: inv.differences || '',
            note: inv.note || '',
            date: inv.date || '',
            scriptDate: inv.scriptDate || '',
            vatNumber: inv.vatNumber,
            _id: inv._id
          }))
        } catch (error) {
          swal.fire({
            icon: 'error',
            title: 'Eroare!',
            text: `Request failed: ${error.message}`,
            timer: 2000,
            showConfirmButton: false
          })
          console.error('Error fetching inventare:', error)
        } finally {
          clearTimeout(this.loadingTimeout)
          this.loading = false
        }
      },
      editInventory (row) {
        const externalLocationId = this.selectedLocation && this.selectedLocation.true_id
        this.$router.push(`/management/inventory/edit/${row.vatNumber}/${row.series}/${row.number}/${externalLocationId}`)
      },
      async downloadExcel (row) {
        const series = row.series
        const number = row.number
        const externalCompanyId = this.companyID
        const externalLocationId = this.selectedLocation && this.selectedLocation.true_id

        if (!series || !number) {
          alert('Missing series or number.')
          return
        }

        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/inventar/${series}-${number}/xls?vatNumber=${row.vatNumber}&externalCompanyId=${externalCompanyId}&externalLocationId=${externalLocationId}`

        try {
          const response = await fetch(url)
          if (response.ok) {
            const blob = await response.blob()
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = `${series}-${number}.xls`
            link.click()
            URL.revokeObjectURL(link.href)
          } else {
            console.error('Error downloading:', response.statusText)
          }
        } catch (error) {
          console.error('Error fetching:', error)
        }
      },
      async downloadPdf (row) {
        const series = row.series
        const number = row.number
        const externalCompanyId = this.companyID
        const externalLocationId = this.selectedLocation && this.selectedLocation.true_id

        if (!series || !number) {
          alert('Missing series or number.')
          return
        }

        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/inventar/${series}-${number}/pdf?vatNumber=${row.vatNumber}&externalCompanyId=${externalCompanyId}&externalLocationId=${externalLocationId}`

        try {
          const response = await fetch(url)
          if (response.ok) {
            const blob = await response.blob()
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = `${series}-${number}.pdf`
            link.click()
            URL.revokeObjectURL(link.href)
          } else {
            console.error('Error downloading:', response.statusText)
          }
        } catch (error) {
          console.error('Error fetching:', error)
        }
      },
      deleteInventory (row) {
        swal({
          title: 'Confirmare ștergere',
          text: `Sigur dorești să ștergi inventarul ${row.series} ${row.number}?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Da, șterge',
          cancelButtonText: 'Anulează',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          buttonsStyling: false
        }).then((result) => {
          if (result) {
            fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/inventar`, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                externalCompanyId: this.companyID,
                id: row._id
              })
            })
              .then(response => {
                if (!response.ok) {
                  throw new Error('Failed to delete inventar')
                }
                return response.json()
              })
              .then(() => {
                swal({
                  title: 'Șters!',
                  text: 'Inventarul a fost șters.',
                  icon: 'success',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success'
                })
                this.fetchInventare()
              })
              .catch(error => {
                swal({
                  title: 'Eroare',
                  text: `Ștergerea a eșuat: ${error.message}`,
                  icon: 'error',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger'
                })
              })
          }
        })
      }
    }
  }
</script>

<style scoped>
  .inventarView .edit {
    margin: 0 !important;
    margin-left: 10px !important;
  }
  .el-pagination {
    text-align: center !important;
  }
  .inventarView .downl {
    background: green !important;
    max-width: fit-content !important;
  }
  .inventarView .action-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center; /* Aliniază butoanele pe axa verticală */
    margin-bottom: 15px;
  }

  .left-buttons {
    display: flex;
    align-items: center;
  }

  .left-buttons el-button {
    margin-right: 10px; /* Spațiere între butoane */
  }

  .right-button {
    margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
  }
</style>
<style>
  .inventarView .el-table .cell {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .inventarView .el-table .cell .alignRight {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end !important;
  }
  .btn-success {
    width: auto !important;
    height: auto !important;
    margin-right: 20px !important;
  }
  .arrow-box {
    display: inline-block;
    font-size: 18px; /* mărimea săgeții */
    padding: 4px 6px;
    border: 1px solid #674BD2 !important; /* border violet */
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    user-select: none;
    transition: background-color 0.2s, border-color 0.2s, color 0.2s;
    color: #674BD2; /* culoarea săgeții */
  }

  .arrow-box:hover {
    background-color: #674BD2 !important;
    border-color: #674BD2 !important;
    color: #fff !important; /* săgeata albă la hover */
  }

  /* Dropdown menu */
  .custom-dropdown-menu {
    min-width: 180px;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Inventory/ManagementInventory.vue